import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import Language from "@material-ui/icons/Language";
import Person from "@material-ui/icons/PersonOutline";
import Search from "@material-ui/icons/Search";
import Heart from "@material-ui/icons/FavoriteBorder";
import Shop from "@material-ui/icons/ShoppingCart";
import Badge from "../badge";
import { Link } from "react-router-dom";
import headerStyle from "./headerStyle";
import Exit from "@material-ui/icons/ExitToApp";
import Login from "./Login";
import AdvancedSearch from "./../../components/AdvancedSearch";
import GridContainer from "../../components/GridContainer";
import LanguageDialog from "./languageDialog";
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      loginmobileOpen: false,
      loading: false,
      open: false,
      langopen: false,
      isopen: false
    };
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  handleLoginDrawerToggle = () => {
    this.setState({ loginmobileOpen: !this.state.loginmobileOpen });
  };
  headerColorChange = () => {
    const { classes, color, changeColorOnScroll } = this.props;
    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
      // document.body
      //   .getElementsByTagName("header")[0]
      //   .classList.add(classes.scroll);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes.scroll);
    }
  };
  componentDidMount() {
    if (this.props.changeColorOnScroll) {
      window.addEventListener("scroll", this.headerColorChange);
    }
  }
  componentWillUnmount() {
    if (this.props.changeColorOnScroll) {
      window.removeEventListener("scroll", this.headerColorChange);
    }
  }
  render() {
    const {
      classes,
      color,
      rightLinks,
      leftLinks,
      brand,
      dir,
      lang,
      count,
      isLogin,
      multiLang,
      setLang
    } = this.props;
    const { isopen } = this.state;
    const closeDialog = e => this.setState({ open: false });

    const appBarClasses = classNames({
      [classes.appBar]: true,
      [classes[color]]: color
    });
    const brandComponent = brand ? (
      <Button className={classes.title}>{brand}</Button>
    ) : null;
    return (
      <AppBar className={appBarClasses}>
        <GridContainer>
          <Toolbar style={{ width: "100%", padding: "0" }}>
            {leftLinks !== undefined ? brandComponent : null}
            <div className={classes.flex}>
              {leftLinks !== undefined ? (
                <Hidden smDown implementation="css">
                  {leftLinks}
                </Hidden>
              ) : (
                <Hidden mdUp implementation="css">
                  {brandComponent}
                </Hidden>
              )}
            </div>
            <div style={{ width: "100%" }}>
              <Hidden smDown implementation="css">
                {rightLinks}
              </Hidden>
            </div>
            <Hidden smDown>
              <div className={classes.hidden} id="hidden">
                <Button className={classes.scrollBtn}>
                  <Heart />
                </Button>
                <Button className={classes.scrollBtn}>
                  <Person />
                </Button>
                <Button className={classes.scrollBtn}>
                  <Search />
                </Button>
                <Button className={classes.shop}>
                  <Badge count={count}>
                    <Shop />
                  </Badge>
                </Button>
              </div>
            </Hidden>
          </Toolbar>
        </GridContainer>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={dir === "ltr" ? "right" : "left"}
            open={this.state.mobileOpen}
            classes={{
              paper: classes.drawerPaper
            }}
            onClose={this.handleDrawerToggle}
          >
            <div
              style={{ direction: dir }}
              className={`${classes.appResponsive} ${
                dir === "rtl" ? "farsi" : ""
              }`}
            >
              {leftLinks}
              {rightLinks}
            </div>
          </Drawer>
        </Hidden>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={dir === "ltr" ? "right" : "left"}
            open={this.state.loginmobileOpen}
            classes={{
              paper: classes.drawerPaper + " " + classes.drawerLogin
            }}
            onClose={this.handleLoginDrawerToggle}
          >
            <div className={classes.closeButton}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => this.setState({ loginmobileOpen: false })}
              >
                <Close />
              </IconButton>
            </div>
            <div
              style={{ direction: dir }}
              className={`${classes.appResponsive} ${
                dir === "rtl" ? "farsi" : ""
              }`}
            >
              {leftLinks}
              {rightLinks}
            </div>
          </Drawer>
        </Hidden>

        <Hidden mdUp implementation="js">
          <div
            className={dir === "ltr" ? classes.fixedmenu : classes.fixedmenuFa}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={this.handleLoginDrawerToggle}
            >
              <Menu />
            </IconButton>

            <div className={classes.responsivemenuContent}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => this.setState({ langopen: true })}
              >
                <Language />
              </IconButton>
              <LanguageDialog
                lang={lang}
                setLang={setLang}
                multiLang={multiLang}
                open={this.state.langopen}
                close={() => this.setState({ langopen: false })}
              />
              <Button
                className={
                  dir === "ltr"
                    ? classes.responsiveButton
                    : classes.responsiveButtonRtl
                }
              >
                <Heart />
              </Button>
              {!isLogin ? (
                <>
                  <Login
                    setUser={this.props.setUser}
                    lang={this.props.lang}
                    dir={this.props.dir}
                    multiLang={this.props.multiLang}
                    myInvoice={this.props.myInvoice}
                    header={true}
                    isopen={isopen}
                    close={() => this.setState({ isopen: false })}
                    setIsopen={e => this.setState({ isopen: e })}
                  />
                </>
              ) : (
                <Button
                  className={
                    classes.Singout +
                    " " +
                    (dir === "ltr"
                      ? classes.responsiveButton
                      : classes.responsiveButtonRtl)
                  }
                  onClick={() => window.location.replace("/profile")}
                >
                  <Person />
                </Button>
              )}
              {isLogin && (
                <Button
                  variant="contained"
                  className={
                    classes.Singout +
                    " " +
                    (dir === "ltr"
                      ? classes.responsiveButton
                      : classes.responsiveButtonRtl)
                  }
                  color="primary"
                  disabled={this.loading}
                  onClick={() => {
                    this.setState({ loading: true });
                    this.props.logOut();
                    this.setState({ loading: false });
                  }}
                >
                  <Exit />
                </Button>
              )}
              <Button
                className={
                  dir === "ltr"
                    ? classes.responsiveButton
                    : classes.responsiveButtonRtl
                }
                onClick={() => this.setState({ open: true })}
              >
                <Search />
              </Button>
              {this.state.open && (
                <AdvancedSearch
                  open={this.state.open}
                  close={closeDialog}
                  lang={this.props.lang}
                  dir={this.props.dir}
                />
              )}
              <Button
                className={
                  dir === "ltr"
                    ? classes.shopResponsiveButton
                    : classes.shopResponsiveButtonRtl
                }
              >
                <Link to="/cart">
                  <Badge count={count} cl>
                    <Shop />
                  </Badge>
                </Link>
              </Button>
              {/* <Button className={dir==="ltr" ? classes.shopResponsiveButton : classes.shopResponsiveButtonRtl}>
                  <Link to="/cart">
                    <Badge count={count} cl>
                      <Shop />
                    </Badge>
                  </Link>
                </Button> */}
              {/* </div> */}
            </div>
          </div>
        </Hidden>
      </AppBar>
    );
  }
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.any,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};

export default withStyles(headerStyle)(Header);
